// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.ExchangeRate')
class Orders__ExchangeRate {
    @jsonProperty(() => Orders__ExchangeRate.Id)
    id: Orders__ExchangeRate.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "string" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "name", "amountInChf", "order", "history", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "name", "amountInChf", "order", "history", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "name", "amountInChf", "order", "history", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "name": "string", "amountInChf": "number", "order": "number", "history": "Orders.ExchangeRateHistory[]", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "string" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ history: () => Orders.ExchangeRateHistory } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = String;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θname = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θamountInChf = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θorder = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θhistory = Signals.proxySignalDeferred<Orders.ExchangeRateHistory[]>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.ExchangeRate' {
        return 'Orders.ExchangeRate'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.ExchangeRate' {
        return 'Orders.ExchangeRate'
    }

    static get __baseType(): 'Orders.ExchangeRate' {
        return 'Orders.ExchangeRate'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.ExchangeRate' {
        return 'Orders.ExchangeRate'
    }

    get [BoInfoSymbol]() {
        return Orders__ExchangeRate[BoInfoSymbol]
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(coerceDataType(name, 'string', false, true))
    }

    get amountInChf(): number {
        return this.θamountInChf?.()
    }

    set amountInChf(amountInChf) {
        this.θamountInChf.set(coerceDataType(amountInChf, 'number', false, true))
    }

    get order(): number {
        return this.θorder?.()
    }

    set order(order) {
        this.θorder.set(coerceDataType(order, 'number', false, true))
    }

    get history(): Orders.ExchangeRateHistory[] {
        return this.θhistory?.()
    }

    set history(history) {
        this.θhistory.set(coerceDataType(history, Orders.ExchangeRateHistory, true, true))
        this.history?.forEach?.(item => { if (item && "exchangeRate" in item) item.exchangeRate = this as any })
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__ExchangeRate>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                history: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__ExchangeRate()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__ExchangeRate>, restrictToClass?: Class<Partial<Orders__ExchangeRate>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('name', 'amountInChf', 'order', 'history', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    static convert(amount: number, from: This.Currency, to: This.Currency): number {
        return amount * from.amountInChf / to.amountInChf
    }

    static async getForDate(date: Date, currency: This.Currency): Promise<number> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<number>('Entity', 'Orders', 'ExchangeRate', undefined, 'getForDate', args)
        return result
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__ExchangeRate {
        return equal(this, other)
    }
}

namespace Orders__ExchangeRate { }

export import ExchangeRate = Orders__ExchangeRate
setTimeout(() => {
    jsonProperty(() => String)(Orders__ExchangeRate.prototype, 'name')
    jsonProperty(() => Number)(Orders__ExchangeRate.prototype, 'amountInChf')
    jsonProperty(() => Number)(Orders__ExchangeRate.prototype, 'order')
    jsonArrayProperty(() => Orders.ExchangeRateHistory)(Orders__ExchangeRate.prototype, 'history')
    jsonProperty(() => Date)(Orders__ExchangeRate.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__ExchangeRate.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__ExchangeRate.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__ExchangeRate.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__ExchangeRate.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__ExchangeRate.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__ExchangeRate.prototype, 'versionNumber')
})

export const ExchangeRateθId = String;

export type ExchangeRateθId = string;

namespace Orders__ExchangeRate {
    export type Id = NominalType<string, 'Orders.ExchangeRate'>

}
